import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import React, { Component } from 'react';
import FillBlankResult from '../../fill_blank/Result';
var RichFillBlankResult = /*#__PURE__*/function (_Component) {
  function RichFillBlankResult() {
    _classCallCheck(this, RichFillBlankResult);
    return _callSuper(this, RichFillBlankResult, arguments);
  }
  _inherits(RichFillBlankResult, _Component);
  return _createClass(RichFillBlankResult, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(FillBlankResult, Object.assign({}, this.props, {
        richFITB: true
      }));
    }
  }]);
}(Component);
export { RichFillBlankResult as default };